import wrap from './wrap';
import wrapPage from './wrapPage';

export const wrapRootElement = wrap;
export const wrapPageElement = wrapPage;
